import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { useLanguage } from '../contexts/LanguageContext';

export const Settings = () => {
  const [rate, setRate] = useState(25000);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/settings`,
        { withCredentials: true }
      );
      setRate(response.data.eur_vnd_rate);
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error('Erreur lors du chargement des paramètres');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/settings`,
        { eur_vnd_rate: parseFloat(rate) },
        { withCredentials: true }
      );
      toast.success('Paramètres enregistrés');
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Erreur lors de l\'enregistrement');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto"></div>
            <p className="mt-4 text-sm text-slate-600">Chargement...</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">Paramètres</h1>
          <p className="text-sm text-slate-600 mt-1">Configuration du système</p>
        </div>

        <Card className="border-slate-200 shadow-sm max-w-2xl">
          <CardHeader>
            <CardTitle className="text-lg font-medium">Taux de change</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="rate">Taux EUR vers VND</Label>
                <Input
                  data-testid="exchange-rate-input"
                  id="rate"
                  type="number"
                  step="0.01"
                  min="0"
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                  required
                  className="max-w-md"
                />
                <p className="text-xs text-slate-500">1 EUR = {parseFloat(rate).toLocaleString()} VND</p>
              </div>

              <Button
                data-testid="save-settings-button"
                type="submit"
                className="bg-slate-900 hover:bg-slate-800"
                disabled={saving}
              >
                {saving ? 'Enregistrement...' : 'Enregistrer'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};
